import Icon from "@material-ui/icons/SupervisedUserCircle";
import InvoiceList from "./InvoiceList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "invoices",
  list: InvoiceList,
  icon: Icon,
};
